import throttle from 'lodash/throttle';

import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import {
    getLocalAudioTrack
} from '../../../react/features/base/tracks/functions.any';

import { enableNoiseWhenReady } from './actions';
StateListenerRegistry.register(
    /* selector */ state => state['features/base/participants'].localScreenShare,
    /* listener */ (track, { getState }, deletedTrack) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const isSharingEnabled = Boolean(track && !deletedTrack);

        toggleSimulcast(conference, isSharingEnabled);
    }
);


function toggleSimulcast(conference, stateSimulcast) {
    if (!conference?.jvbJingleSession) {
        return;
    }
    conference.jvbJingleSession.peerconnection.options.disableSimulcast = stateSimulcast;
}

StateListenerRegistry.register(
    /* selector */ state => getLocalAudioTrack(state['features/base/tracks'])?.jitsiTrack?.deviceId,
    /* listener */ throttle(async (deviceId, { dispatch }) => {
        if (typeof deviceId === 'undefined') {
            return;
        }

        dispatch(enableNoiseWhenReady(deviceId));
    }, 500));
